import { SummaryRow } from '../../../Summary/SummaryRow';
import { VQ } from '../../../../store/student/types';
import { IVisaPrepForm } from '../../../../types';
import { useTranslation } from "react-i18next";

function VisaPrepFeedbackInfo(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.OTHER_FEEDBACK}
        value={props.otherFeedback}
        label={t('forms.visa:otherFeedback')}
        fullLabel={'Is there any other information you wish to be considered as part of your application?'}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.DIFFICULTIES_FEEDBACK}
        value={props.difficultiesFeedback}
        label={t('forms.visa:anyDifficulties')}
        fullLabel={'If you have any difficulties with any question or require clarity, please list the question here:'}
      />
    </>
  );
}

export default VisaPrepFeedbackInfo;
